// extracted by mini-css-extract-plugin
export var card = "_lx-0";
export var content = "_lx-2";
export var details = "_lx-3";
export var icon = "_lx-1";
export var iconBlue = "_lx-5";
export var iconBrand = "_lx-4";
export var iconGrayBlue = "_lx-6";
export var iconGreen = "_lx-7";
export var iconIndigo = "_lx-8";
export var iconOrange = "_lx-9";
export var iconPurple = "_lx-a";
export var iconRed = "_lx-b";
export var iconWarning = "_lx-c";